import axios from 'axios';

// For production environment
const prodAxios = axios.create({
  baseURL: `https://clipthoughts.com/api`,
});

const devAxios = axios.create({
  baseURL: 'http://localhost:8080/api',
});

// Export the appropriate instance based on the environment
const axiosInstance = process.env.NODE_ENV === 'development' ? devAxios : prodAxios;

export default axiosInstance;
